<template>

    <div v-if="show" class="terms__container">

        <p class="terms__text">{{ $t(text) }}</p>

        <a class="terms__btn" @click="consult">{{ $t('global_banner_cgu_update_cta') }}</a>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Firebase from '../modules/firebase'
import Agreements from '../modules/agreements'

export default {

    name: 'agreements-update',

    computed: {
        ...Vuex.mapGetters(['isConnected'])
    },

    watch: {
        isConnected: function (isConnected) {
            if (isConnected) {
                this.checkAgreements()
            }
        }
    },

    data() {
        return {
            show: false,
            text: ''
        }
    },

    mounted() {
        this.show = false
        this.text = ''
    },

    methods: {

        checkAgreements() {

            Firebase.getValue('last_terms_update')
                .then(lastTermsUpdate => {

                    Firebase.getValue('last_privacy_update')
                        .then(async lastPrivacyUpdate => {

                            const agreements = await Agreements.get()

                            if (agreements) {

                                const needReadTerms = !(lastTermsUpdate && agreements.terms && new Date(agreements.terms).getTime() > new Date(lastTermsUpdate).getTime())
                                const needReadPrivacy = !(lastPrivacyUpdate && agreements.privacy && new Date(agreements.privacy).getTime() > new Date(lastPrivacyUpdate).getTime())

                                if (needReadTerms || needReadPrivacy) {
                                    if (needReadTerms && needReadPrivacy) {
                                        this.text = 'global_banner_cgu_pp_update'
                                    } else if (needReadTerms) {
                                        this.text = 'global_banner_cgu_update'
                                    } else {
                                        this.text = 'global_banner_pp_update'
                                    }
                                    this.show = true
                                }
                            }
                        })
                        .catch(() => {
                        })
                })
                .catch(() => {
                })
        },

        consult() {

            switch (this.text) {
                case 'global_banner_cgu_update':
                    this.$router.push({path: '/terms'})
                    break
                case 'global_banner_pp_update':
                    this.$router.push({path: '/privacy'})
                    break
                case 'global_banner_cgu_pp_update':
                    this.$router.push({path: '/agreements'})
                    break
            }

            this.show = false

        }

    }

}
</script>

<style lang="scss" scoped>

.terms {

    &__container {

        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 8px;
        box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.16);
        background-color: $midnight;
        @media screen and (min-width: $above-tablet-length) {
            position: absolute;
            border-radius: 8px;
            padding: 12px;
            bottom: 16px;
            left: 16px;
            right: 16px;
        }
    }

    &__text {
        font-size: 13px;
        font-weight: 600;
        line-height: 1.4;
        color: $white;
        text-align: start;
    }

    &__btn {
        font-size: 13px;
        font-weight: bold;
        line-height: 1.23;
        color: $aquamarine;
        min-height: 30px;
        display: flex;
        align-items: center;
        padding-left: 8px;
        cursor: pointer;
    }
}


</style>
